import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const BILLING_HISTORY_QUERY = gql`
  query BillingHistoryQuery($businessEntityUuid: UUID!) {
    billingHistory(businessEntityUuid: $businessEntityUuid) {
      invoiceId
      invoiceUrl
      amount
      chargeDate
      paymentMethod {
        brand
        last4
      }
    }
  }
`;

export function useBillingHistory() {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, error, refetch } = useQuery(BILLING_HISTORY_QUERY, {
    noThrow: true,
    skip: !businessEntityUuid,
    variables: {
      businessEntityUuid,
    },
  });

  useError(error);

  return {
    data: data?.billingHistory || [],
    error,
    loading,
    refetch,
  };
}
